"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guideButtonMenu = void 0;
const GuideButtonCategoryType_1 = require("../../enums/asset/GuideButtonCategoryType");
const GuideButtonKeyType_1 = require("../../enums/asset/GuideButtonKeyType");
const GuideButtonType_1 = require("../../enums/asset/GuideButtonType");
exports.guideButtonMenu = [
    {
        title: 'Games',
        list: [
            {
                title: 'Games Dashboard',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.GAMES}#${GuideButtonType_1.GuideButtonType.GAMES_DASHBOARD}`,
            },
            {
                title: 'Game Design',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.GAMES}#${GuideButtonType_1.GuideButtonType.GAME_DESIGN}`,
            },
            {
                title: 'Game Settings',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.GAMES}#${GuideButtonType_1.GuideButtonType.GAME_SETTINGS}`,
            },
            {
                title: 'User Base',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.GAMES}#${GuideButtonType_1.GuideButtonType.USER_BASE}`,
            },
            {
                title: 'Manage Winners',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.GAMES}#${GuideButtonType_1.GuideButtonType.MANAGE_WINNERS}`,
            },
        ],
    },
    {
        title: 'Game Center',
        list: [
            {
                title: 'Game Center Dashboard',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.GAME_CENTER}#${GuideButtonType_1.GuideButtonType.GAME_CENTER_DASHBOARD}`,
            },
            {
                title: 'General Settings',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.GAME_CENTER}#${GuideButtonType_1.GuideButtonType.GENERAL_SETTINGS}`,
            },
            {
                title: 'Modules',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.GAME_CENTER}#${GuideButtonType_1.GuideButtonType.MODULES}`,
            },
            {
                title: 'User Base',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.GAME_CENTER}#${GuideButtonType_1.GuideButtonType.GAME_CENTER_USER_BASE}`,
            },
            {
                title: 'Rewards Data',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.GAME_CENTER}#${GuideButtonType_1.GuideButtonType.REWARDS_DATA}`,
            },
        ],
    },
    {
        title: 'Gamification',
        list: [
            {
                title: 'Gamification Dashboard',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.GAMIFICATION}#${GuideButtonType_1.GuideButtonType.GAMIFICATION_DASHBOARD}`,
            },
            {
                title: 'Attempts/Unlock',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.GAMIFICATION}#${GuideButtonType_1.GuideButtonType.ATTEMPTS_UNLOCK}`,
            },
            {
                title: 'Adventure Mode',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.GAMIFICATION}#${GuideButtonType_1.GuideButtonType.ADVENTURE_MODE}`,
            },
            {
                title: 'Coins Distribution',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.GAMIFICATION}#${GuideButtonType_1.GuideButtonType.COINS_DISTRIBUTION}`,
            },
            {
                title: 'Unlock Rewards',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.GAMIFICATION}#${GuideButtonType_1.GuideButtonType.UNLOCK_REWARDS}`,
            },
            {
                title: 'Gamification Analytics',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.GAMIFICATION}#${GuideButtonType_1.GuideButtonType.GAMIFICATION_ANALYTICS}`,
            },
        ],
    },
    {
        title: 'Links',
        SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.LINKS}`,
    },
    {
        title: 'Analytics',
        SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.ANALYTICS}`,
    },
    {
        title: 'User Base',
        list: [
            {
                title: 'User Base Dashboard',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.USER_BASE}#${GuideButtonType_1.GuideButtonType.USER_BASE_DASHBOARD}`,
            },
            {
                title: 'Create Email',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.USER_BASE}#${GuideButtonType_1.GuideButtonType.CREATE_EMAIL}`,
            },
        ],
    },
    {
        title: 'Account Pages',
        list: [
            {
                title: 'Profile',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.ACCOUNT_PAGES}#${GuideButtonType_1.GuideButtonType.PROFILE}`,
            },
            {
                title: 'My Organization',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.ACCOUNT_PAGES}#${GuideButtonType_1.GuideButtonType.MY_ORGANIZATION}`,
            },
            {
                title: 'License',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.ACCOUNT_PAGES}#${GuideButtonType_1.GuideButtonType.LICENSE}`,
            },
            {
                title: 'Documents & Agreements',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.ACCOUNT_PAGES}#${GuideButtonType_1.GuideButtonType.DOCUMENT_AND_AGREEMENTS}`,
            },
        ],
    },
    {
        title: 'Manage Users',
        list: [
            {
                title: 'Manage Users List',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.MANAGE_USERS}#${GuideButtonType_1.GuideButtonType.MANAGE_USER_LIST}`,
            },
            {
                title: 'Add User',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.MANAGE_USERS}#${GuideButtonType_1.GuideButtonType.ADD_USER}`,
            },
            {
                title: 'Edit User',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.MANAGE_USERS}#${GuideButtonType_1.GuideButtonType.EDIT_USER}`,
            },
        ],
    },
    {
        title: 'Manage Brands',
        list: [
            {
                title: 'Manage Brands List',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.MANAGE_BRANDS}#${GuideButtonType_1.GuideButtonType.MANAGE_BRANDS_LIST}`,
            },
            {
                title: 'Add Brand',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.MANAGE_BRANDS}#${GuideButtonType_1.GuideButtonType.ADD_BRANDS}`,
            },
            {
                title: 'Edit Brand',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.MANAGE_BRANDS}#${GuideButtonType_1.GuideButtonType.EDIT_BRANDS}`,
            },
        ],
    },
    {
        title: 'Brand Assets',
        list: [
            {
                title: 'Fonts',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.BRAND_ASSETS}#${GuideButtonType_1.GuideButtonType.FONTS}`,
            },
            {
                title: 'Email',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.BRAND_ASSETS}#${GuideButtonType_1.GuideButtonType.EMAIL}`,
            },
            {
                title: 'Time Zone',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.BRAND_ASSETS}#${GuideButtonType_1.GuideButtonType.TIME_ZONE}`,
            },
            {
                title: 'API Access Key',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.BRAND_ASSETS}#${GuideButtonType_1.GuideButtonType.API_ACCESS_KEY}`,
            },
            {
                title: 'Brand Terms',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.BRAND_ASSETS}#${GuideButtonType_1.GuideButtonType.BRAND_TERMS}`,
            },
            {
                title: 'Form Parameters',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.BRAND_ASSETS}#${GuideButtonType_1.GuideButtonType.FORM_PARAMETERS}`,
            },
        ],
    },
    {
        title: 'Data Integration',
        list: [
            {
                title: 'Webhook Dashboard',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.DATA_INTEGRATION}#${GuideButtonType_1.GuideButtonType.WEBHOOK_DASHBOARD}`,
            },
            {
                title: 'Webhook Analytics',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.DATA_INTEGRATION}#${GuideButtonType_1.GuideButtonType.WEBHOOK_ANALYTICS}`,
            },
            {
                title: 'Webhook Create',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.DATA_INTEGRATION}#${GuideButtonType_1.GuideButtonType.WEBHOOK_CREATE}`,
            },
            {
                title: 'Webhook Edit',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.DATA_INTEGRATION}#${GuideButtonType_1.GuideButtonType.WEBHOOK_EDIT}`,
            },
        ],
    },
    {
        title: 'Receipt',
        list: [
            {
                title: 'Dashboard',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.RECEIPT}#${GuideButtonType_1.GuideButtonType.RECEIPT_DASHBOARD}`,
            },
            {
                title: 'Settings',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.RECEIPT}#${GuideButtonType_1.GuideButtonType.RECEIPT_SETTINGS}`,
            },
            {
                title: 'Uploaded Receipt',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.RECEIPT}#${GuideButtonType_1.GuideButtonType.UPLOADED_RECEIPT}`,
            },
            {
                title: 'Analytics',
                SK: `${GuideButtonKeyType_1.GuideButtonKeyType.SK}${GuideButtonCategoryType_1.GuideButtonCategoryType.RECEIPT}#${GuideButtonType_1.GuideButtonType.RECEIPT_ANALYTICS}`,
            },
        ],
    },
];
